const state = {
    prodtype: "computer",
    specification :null,
}

const mutations = {
    SET_PRODTYPE(state, prodtype) {
        state.prodtype = prodtype
    },
    SET_specification(state, specification) {
        state.specification = specification
    }
}

const actions = {
}

const getters = {
    prodtype: (state) => state.prodtype,
    specification: (state) => state.specification,
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
